"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmOrderShippingToJSON = exports.ConfirmOrderShippingFromJSONTyped = exports.ConfirmOrderShippingFromJSON = exports.instanceOfConfirmOrderShipping = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ConfirmOrderShipping interface.
 */
function instanceOfConfirmOrderShipping(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfConfirmOrderShipping = instanceOfConfirmOrderShipping;
function ConfirmOrderShippingFromJSON(json) {
    return ConfirmOrderShippingFromJSONTyped(json, false);
}
exports.ConfirmOrderShippingFromJSON = ConfirmOrderShippingFromJSON;
function ConfirmOrderShippingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'location': !(0, runtime_1.exists)(json, 'location') ? undefined : json['location'],
    };
}
exports.ConfirmOrderShippingFromJSONTyped = ConfirmOrderShippingFromJSONTyped;
function ConfirmOrderShippingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': value.type,
        'location': value.location,
    };
}
exports.ConfirmOrderShippingToJSON = ConfirmOrderShippingToJSON;
